import React, { FC } from 'react';
import BooksLoading from '../../merchant/resources/book/common/loadings/BooksLoading';
import css from './style.module.scss';

export const LoadingIconWithReloadButton: FC = () => {
  return (
    <div className={css.loading_icon}>
      <BooksLoading />
      <div className={css.reload_link}>
        画面が切り替わらない場合は<a href="">こちら</a>をクリックしてください
      </div>
    </div>
  );
};
